import React from "react";

const Hero = () => {
  return (
    <div className="container border-bottom mb-5 ">
      <div className="text-center mt-5 p-3">
        <h1>Fusioninvest  Products</h1>
        <h3 className="text-muted mt-3 fs-4">
          Sleek,modern and instuitive trading platforms
        </h3>
        <p className="mt-2 mb-5 fs-5">
          Check out our{" "}
          <a href="" style={{ textDecoration: "none" }}>
            investment offerings →
          </a>{" "}
        </p>
      </div>
    </div>
  );
};

export default Hero;
